module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAWCAYAAAD0OH0aAAABTUlEQVQ4T43TvVKDQBQF4HNi6bPYh1hAMtn4Juok8b+wsUhhkcIx6GjgVQwZIc4YYuejWFhzHTAsEAJKxTDn23t32UvPD29FZMgdPinTuMEfD2d++A3IbpyjcKI6xmWdoReE9yJykYZITpRVjSginC9CVwSH/0GMQwnyQ1f4N0pAirzgwwGiI/0NsA/aLd1uss/8BuNKXhA6ADQiYKscKoCs0gZqwFbmb6US0Ht6W00lkmN9EGu0FWSVVlMgh4BxJYjRaDRqtMzeJ4C9dTtftcBbrCYSRef5/1MJZv7SBnCWnSJdZTX7W0E5DFdZRp+klMDcX9pRYeUsXDrWWRA+QOQ017PTNZuDeGX9LX0phYVOt10M6wovr++PJE/0KkJHdYxBfC83ZyMeoDEg17k2psoyhtvCSYXCxJG14RTcATIE5bln7V/VjWfl5atDPwLnoNuvyTgrAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/static/images/zhankai .png
// module id = EAYh
// module chunks = 1